import React from "react";
import { Link } from "react-router-dom";
import '../../styles/components/MailButton/MailButton.scss';

const MailButton = ({ mailto, label }) => {
  return (
    <Link
      to='#'
      onClick={(e) => {
        window.location.href = mailto;
        e.preventDefault();
      }}
      className={'mailto-label'}
    >
      {label}
    </Link>
  );
};

export default MailButton;
